import StyledNotice from './StyledNotice';

const TranslationBanner = () => {
  if (!devsite?.translated_banner) {
    return null;
  }

  return <StyledNotice>{devsite.translated_banner}</StyledNotice>;
};

export default TranslationBanner;
